import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { API_URL } from '../../const';
import { MdRefresh } from "react-icons/md";
import axios from 'axios';
import AddLedger from '../payment-receipt/add-ledger/add-ledger';
import AddPayment from '../payment-receipt/add-payment/add-payment';
import BankAccount from '../payment-receipt/bank-account/bank-account';
import CashAccount from '../payment-receipt/cash-account/cash-account';
import Contra from '../payment-receipt/contra/contra';


const PaymentReceipt = () => {

    const location = useLocation();
    const [mode, setMode] = useState(1);
    const [bankBalance, setBankBalance] = useState(0);
    const [cashBalance, setCashBalance] = useState(0);
    const [isRefresh, setRefresh] = useState(false);

    const getBankData = () => {
        axios.post(API_URL.CASH_BANK_LIST, { payment_type: "Bank" }).then((res) => {
            if (res.data.status === 1) {
                if (res.data.data.length > 0) {
                    setBankBalance(res.data.data[res.data.data.length - 1].balance);
                } else {
                    setBankBalance(0);
                }
            }
        });
        setRefresh(false);
    };

    const getCashData = () => {
        axios.post(API_URL.CASH_BANK_LIST, { payment_type: "Cash" }).then((res) => {
            if (res.data.status === 1) {
                if (res.data.data.length > 0) {
                    setCashBalance(res.data.data[res.data.data.length - 1].balance);
                } else {
                    setCashBalance(0);
                }
            }
        });
        setRefresh(false);
    };

    useEffect(() => {
        getBankData();
        getCashData();
    }, []);

    useEffect(() => {
        if (isRefresh) {
            getBankData();
            getCashData();
        }
    }, [isRefresh]);


    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const modeParam = queryParams.get("child-mode");
        if (modeParam) {
            setMode(parseInt(modeParam));
        }
    }, [location.search]);

    const handleModeChange = (newMode) => {
        setMode(newMode);
        const queryParams = new URLSearchParams(location.search);
        queryParams.set("child-mode", newMode);
        window.history.pushState({}, "", `${location.pathname}?${queryParams.toString()}`);
    };

    return (
        <>
            <div className='card'>
                <div className='card-body d-flex' style={{ justifyContent: 'space-between' }}>
                    <div>
                        <button className={`${mode === 1 && 'active'} btn btn-theme button-1 text-white ctm-border-radius p-2 add-person ctm-btn-padding`} onClick={(() => { handleModeChange(1); })}>Payment</button>
                        <button className={`${mode === 2 && 'active'} ms-2 btn btn-theme button-1 text-white ctm-border-radius p-2 add-person ctm-btn-padding`} onClick={(() => { handleModeChange(2); })} >Receipt</button>
                        <button className={`${mode === 3 && 'active'} ms-2 btn btn-theme button-1 text-white ctm-border-radius p-2 add-person ctm-btn-padding`} onClick={(() => { handleModeChange(3); })}> Bank Account</button>
                        <button className={`${mode === 4 && 'active'} ms-2 btn btn-theme button-1 text-white ctm-border-radius p-2 add-person ctm-btn-padding`} onClick={(() => { handleModeChange(4); })}> Cash Account</button>
                        <button className={`${mode === 5 && 'active'} ms-2 btn btn-theme button-1 text-white ctm-border-radius p-2 add-person ctm-btn-padding`} onClick={(() => { handleModeChange(5); })}> Contra</button>
                    </div>
                    <div className='d-flex'>
                        <div className='amount-total'>
                            <div><strong className='mr-2'>Bank balance: ₹ {bankBalance.toFixed(2)}</strong></div>
                            <div><strong>Cash balance: ₹ {cashBalance.toFixed(2)}</strong></div>
                        </div>
                        <div className='ms-2' style={{ cursor: 'pointer' }} onClick={() => { setRefresh(true) }}><MdRefresh size={20} /></div>
                    </div>
                </div>
                <div className='card-body'>
                    {
                        mode === 1 && <AddPayment />
                    }
                    {
                        mode === 2 && <AddLedger />
                    }
                    {
                        mode === 3 && <BankAccount />
                    }
                    {
                        mode === 4 && <CashAccount />
                    }
                    {
                        mode === 5 && <Contra />
                    }
                </div>
            </div>
        </>
    )
}

export default PaymentReceipt;
